export const S3_AWS_KMS_KEY_ID = "9d12a41d-9c07-4d90-9e20-1355fdd520a6";

export const JUMIO_CALLBACK_URL = "https://www.bixin.com/trade/kyc";
// export const REACT_APP_HOSTBASE_URL_HK = "https://gateway.bixin.com";
export const SITE_SERVER_API = "https://testgateway.bixin.com";
export const EXCHANGE_TRADE_DOMAIN = "https://testgateway.bixin.com";
export const PRO_ENV = "PROD";
